import {Component, inject, signal, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatCardModule} from '@angular/material/card';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {PasswordStrengthValidator} from '../password-strenth.validators';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-forgot-password',
  imports: [
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatIconModule,
    MatProgressBarModule
  ],
  templateUrl: './forgot-password.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
  private readonly auth = inject(AuthService);
  readonly loading = signal(false);
  private readonly router = inject(Router);
  readonly step = signal<'forgot' | 'reset'>('forgot')
  readonly error = signal<string | null>(null);
  private readonly snackBar = inject(MatSnackBar);

  readonly forgotPasswordForm = new FormGroup({
    emailId: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.email]})
  });

  readonly resetPasswordForm = new FormGroup({
    otp: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.pattern(/^\d{6}$/)]
    }),
    newPassword: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, PasswordStrengthValidator]
    })
  });

  submitEmail(form: FormGroup) {
    this.loading.set(true);
    this.auth.forgotPassword(form.controls['emailId'].value).subscribe({
      next: (result) => {
        this.step.set('reset');
        this.loading.set(false);
        this.snackBar.open(` ${result.message}.`, 'Dismiss', { duration: 3000 });
      },
      error: (err: Error) => {
        this.loading.set(false);
        this.error.set(err.message || 'Failed to sent otp.');
      }
    });
  }

  resetPassword(form: FormGroup) {
    if (form.invalid) {
      form.markAllAsTouched();
      return;
    }
    this.loading.set(true);
    this.error.set(null);
    this.auth.resetPassword(this.forgotPasswordForm.controls['emailId'].value, form.controls['otp'].value, form.controls['newPassword'].value).subscribe({
      next: (result) => {
        this.loading.set(false);
        this.router.navigate(['/login']);
        this.snackBar.open(` ${result.message}.`, 'Dismiss', { duration: 3000 });
      },
      error: (err: Error) => {
        this.loading.set(false);
        this.error.set(err.message || 'Failed to reset password.');
      }
    });
  }

  backToLogin() {
    this.router.navigate(['/login']);
  }


}
